import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { AnalyticsBrowser } from '@segment/analytics-next';

const useSegment = () => {
  const { segmentKey } = useSelector((state) => state.get('config').toJS());
  const publicGuid = Cookies.get('blueboxpublic');

  useEffect(() => {
    if (segmentKey && !window?.segment?.initialized) {
      AnalyticsBrowser.load({
        writeKey: segmentKey,
      }).then((analytics) => {
        const analyticsInstance = analytics[0];
        analyticsInstance?.identify(publicGuid);
        window.segment = { ...analyticsInstance };
      });
    }
  }, [segmentKey, publicGuid]);
};

export default useSegment;
